import { api } from "../configs/apiConfig";

const USER_POSITION_ENDPOINT = '/userposition';

class UserPositionService {
    // Get all user positions
    async getAllUserPositions() {
        try {
            const response = await api.get(USER_POSITION_ENDPOINT);
            return response.data;
        } catch (error) {
            console.error('Error fetching user positions:', error);
            throw error;
        }
    }

    // Get a specific user position by ID
    async getUserPositionById(id) {
        try {
            const response = await api.get(`${USER_POSITION_ENDPOINT}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching user position with ID ${id}:`, error);
            throw error;
        }
    }

    // Get user positions by user ID
    async getUserPositionsByUserId(userId) {
        try {
            const response = await api.get(`${USER_POSITION_ENDPOINT}/user/${userId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching positions for user ${userId}:`, error);
            throw error;
        }
    }

    // Get user positions by organizational unit ID
    async getUserPositionsByUnitId(unitId) {
        try {
            const response = await api.get(`${USER_POSITION_ENDPOINT}/unit/${unitId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching positions for unit ${unitId}:`, error);
            throw error;
        }
    }

    // Add a new user position (simple add)
    async addUserPosition(positionData) {
        try {
            const response = await api.post(USER_POSITION_ENDPOINT, {
                userId: positionData.userId,
                organizationalUnitId: positionData.organizationalUnitId,
                positionTitle: positionData.positionTitle,
                isManager: positionData.isManager
            });
            return response.data;
        } catch (error) {
            console.error('Error adding user position:', error);
            throw error;
        }
    }

    // Update an existing user position
    async updateUserPosition(id, positionData) {
        try {
            await api.put(`${USER_POSITION_ENDPOINT}/${id}`, positionData);
        } catch (error) {
            console.error(`Error updating user position with ID ${id}:`, error);
            throw error;
        }
    }

    // Delete a user position
    async deleteUserPosition(id) {
        try {
            await api.delete(`${USER_POSITION_ENDPOINT}/${id}`);
        } catch (error) {
            console.error(`Error deleting user position with ID ${id}:`, error);
            throw error;
        }
    }

    // Assign a user to an organizational unit (creates both position and appointment)
    async assignUserToUnit(assignRequest) {
        try {
            const response = await api.post(`${USER_POSITION_ENDPOINT}/assign`, assignRequest);
            return response.data;
        } catch (error) {
            console.error('Error assigning user to unit:', error);
            throw error;
        }
    }
}

export default new UserPositionService(); 